// change_pw_ui_v1: modal เปลี่ยนรหัสผ่านสำหรับระบบบิล
import React, { useState } from 'react';
import { X } from 'lucide-react';
import API from './api';

export default function BillChangePasswordModal({ onClose }) {
  const [form, setForm] = useState({ current_password: '', new_password: '', confirm_password: '' });
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState(false);

  const set = function (k, v) { setForm(Object.assign({}, form, { [k]: v })); };

  const submit = async function () {
    setError('');
    if (!form.current_password || !form.new_password) { setError('กรุณากรอกข้อมูลให้ครบ'); return; }
    if (form.new_password.length < 6) { setError('รหัสผ่านใหม่ต้องมีอย่างน้อย 6 ตัวอักษร'); return; }
    if (form.new_password !== form.confirm_password) { setError('รหัสผ่านใหม่และยืนยันไม่ตรงกัน'); return; }
    setSaving(true);
    try {
      await API.put('/api/bill/auth/change-password', {
        current_password: form.current_password,
        new_password: form.new_password,
      });
      // สำเร็จ: รหัสเปลี่ยนแล้ว session เก่าถูก revoke -> ต้อง login ใหม่
      setDone(true);
      setTimeout(function () {
        try { localStorage.removeItem('bill_token'); } catch (e) {}
        try { localStorage.removeItem('bill_user'); } catch (e) {}
        window.location.href = '/';
      }, 1800);
    } catch (err) {
      setError((err.response && err.response.data && err.response.data.error) || 'เปลี่ยนรหัสผ่านไม่สำเร็จ');
      setSaving(false);
    }
  };

  const overlay = {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    background: 'rgba(15,23,42,0.45)', display: 'flex',
    alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 16,
  };
  const box = {
    background: 'white', borderRadius: 14, padding: 24,
    width: '100%', maxWidth: 380, fontFamily: 'Inter, sans-serif',
    boxShadow: '0 10px 40px rgba(0,0,0,0.18)',
  };
  const label = { fontSize: 13, color: '#475569', fontWeight: 600 };
  const input = {
    width: '100%', padding: 10, borderRadius: 8, border: '1px solid #e2e8f0',
    fontSize: 14, marginTop: 4, marginBottom: 14, boxSizing: 'border-box',
  };

  return (
    <div style={overlay} onClick={onClose}>
      <div style={box} onClick={function (e) { e.stopPropagation(); }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 18 }}>
          <strong style={{ fontSize: 17, color: '#0f172a' }}>เปลี่ยนรหัสผ่าน</strong>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8', padding: 4 }}>
            <X size={20} />
          </button>
        </div>

        {done ? (
          <div style={{ background: '#ecfdf5', color: '#047857', padding: 16, borderRadius: 8, fontSize: 14, textAlign: 'center' }}>
            ✅ เปลี่ยนรหัสผ่านสำเร็จ<br />กำลังออกจากระบบเพื่อเข้าสู่ระบบใหม่...
          </div>
        ) : (
          <div>
            <div style={label}>รหัสผ่านปัจจุบัน</div>
            <input type="password" value={form.current_password}
              onChange={function (e) { set('current_password', e.target.value); }}
              style={input} autoComplete="current-password" />

            <div style={label}>รหัสผ่านใหม่</div>
            <input type="password" value={form.new_password}
              onChange={function (e) { set('new_password', e.target.value); }}
              placeholder="อย่างน้อย 6 ตัว" style={input} autoComplete="new-password" />

            <div style={label}>ยืนยันรหัสผ่านใหม่</div>
            <input type="password" value={form.confirm_password}
              onChange={function (e) { set('confirm_password', e.target.value); }}
              style={input} autoComplete="new-password" />

            {error && (
              <div style={{ background: '#fef2f2', color: '#dc2626', padding: 10, borderRadius: 8, fontSize: 13, marginBottom: 12 }}>
                ⚠️ {error}
              </div>
            )}

            <div style={{ display: 'flex', gap: 10, marginTop: 4 }}>
              <button onClick={onClose} disabled={saving}
                style={{ flex: 1, padding: 11, borderRadius: 8, border: '1px solid #e2e8f0', background: 'white', color: '#475569', cursor: 'pointer', fontSize: 14, fontFamily: 'inherit' }}>
                ยกเลิก
              </button>
              <button onClick={submit} disabled={saving}
                style={{ flex: 1, padding: 11, borderRadius: 8, border: 'none', background: saving ? '#94d3bf' : '#10b981', color: 'white', cursor: saving ? 'default' : 'pointer', fontSize: 14, fontWeight: 600, fontFamily: 'inherit' }}>
                {saving ? 'กำลังบันทึก...' : 'บันทึก'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
